export default {
  countyPopulationDataUrl: 'data/county_population_data.json',
  atuPopulationDataUrl: 'data/atu_population_data.json',
  cityPopulationDataUrl: 'data/city_population_data.json',
  countyTotalProjectsDataUrl: 'data/county_total_projects_data.json',
  cityProjectsDataUrl: 'data/city_projects_data.json',
  countyProjectsDataUrl: 'data/county_projects_data.json',
};
